module.exports = __webpack_public_path__ + "static/media/dark-theme-duration.7486759e.svg";